import PropTypes from 'prop-types';
import React from 'react';
import { ContentFeedView, ScheduleEntryView, TimeRangeEditor } from '..';
import { isEmpty } from '../../utils/isEmpty';
import { sortBy } from '../../utils/sort';
import { timeStrIncrement, timeStrToNum } from '../../utils/time';
import Button from '../widgets/Button';
import Icon from '../widgets/Icon';
import './styles.scss';

class DailyScheduleView extends React.Component {
  static propTypes = {
    notifSend: PropTypes.array.isRequired,
    smartBoardEnabled: PropTypes.bool,
    day: PropTypes.string.isRequired,
    schedule: PropTypes.array.isRequired,
    onScheduleFeedChange: PropTypes.func.isRequired,
    onScheduleTimeSlotDelete: PropTypes.func.isRequired,
    onAddScheduleTimeSlot: PropTypes.func.isRequired,
    onUpdateScheduleTimeSlot: PropTypes.func.isRequired,
    onReschedule: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      adding: false,
      newTimeSlot: null,
      schedule: props.schedule,
      overlaps: {},
      expanded: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.props.schedule !== newProps.schedule) {
      this.setState({schedule: newProps.schedule});
    }
  }

  getActionBar() {
    if (this.state.editing) {
      return (
        <div className="actions">
          <Button onClick={this.handleCancel} secondary>Cancel</Button>
          <Button onClick={this.handleSave}>Save</Button>
        </div>
      );
    } else if (this.state.adding) {
      return (
        <div className="actions">
          <TimeRangeEditor editing onTimeRangeChange={this.handleNewTimeSlotChange}
                           timeRange={this.state.newTimeSlot}/>
          <div className="cancel-save">
            <Button onClick={this.handleCancelAdd} secondary>Cancel</Button>
            <Button onClick={this.handleSaveTimeSlot}>Save</Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="actions">
          <Button onClick={this.handleReschedule}>Reschedule</Button>
          <span className="spacer"/>
          <Button onClick={this.handleAddClick}>Add Time Slot</Button>
        </div>
      );
    }
  }

  validateTime = (schedule_action, set_state) => {
    let t_start = new Date(`2017-1-1 ${this.state.newTimeSlot.start_time}`)
    let t_end = new Date(`2017-1-1 ${this.state.newTimeSlot.end_time}`)
    let start = `${`${t_start.getHours()}`.padStart(2, '0')}:${`${t_start.getMinutes()}`.padStart(2, '0')}`
    let end = `${`${t_end.getHours()}`.padStart(2, '0')}:${`${t_end.getMinutes()}`.padStart(2, '0')}`
    let start_reg = Number(start.replace(/\s|-|:/g, ''))
    let end_reg = Number(end.replace(/\s|-|:/g, ''))


    let is_overlaping = false

    this.state.schedule.map(
      (content) => {
        let content_t_start = new Date(`2017-1-1 ${content.start_time}`)
        let content_t_end = new Date(`2017-1-1 ${content.end_time}`)
        let content_start = `${`${content_t_start.getHours()}`.padStart(2, '0')}:${`${content_t_start.getMinutes()}`.padStart(2, '0')}`
        let content_end = `${`${content_t_end.getHours()}`.padStart(2, '0')}:${`${content_t_end.getMinutes()}`.padStart(2, '0')}`
        let content_start_reg = Number(content_start.replace(/\s|-|:/g, ''))
        let content_end_reg = Number(content_end.replace(/\s|-|:/g, ''))

        if(
          content_start_reg >= start_reg && content_start_reg < end_reg ||
          content_end_reg > start_reg && content_end_reg <= end_reg ||
          content_start_reg <= start_reg && content_end_reg >= end_reg
        ){
          is_overlaping = true
        }
      }
    )
    
    if(is_overlaping == true){
      this.props.notifSend({
        message: "Sorry, A Special Content Exists Within This Time Range",
        kind: "alert",
        dismissAfter: 5000,
      })
    }else if(start_reg>end_reg){
      this.props.notifSend({
        message: "Time start can not be greater than Time end",
        kind: "alert",
        dismissAfter: 5000,
      })
    }else if(start_reg === end_reg){
      this.props.notifSend({
          message: `end Time ${end} can not be equal end start Time  ${start}`,
          kind: "alert",
          dismissAfter: 5000,
        }
      )
    }else{
      schedule_action();
      set_state();
    }
  }

  getNextTimeRange() {
    // Check for length 1 since there is always a default entry.
    if (this.state.schedule.length === 0) {
      return {start_time: '08:00', end_time: '08:15'};
    } else {
      const lastSchedule = this.state.schedule[this.state.schedule.length - 1];

      return {
        start_time: lastSchedule.end_time,
        end_time: timeStrIncrement(lastSchedule.end_time, {minutes: 15}),
      };
    }
  }

  getOverlaps(schedule) {
    const overlaps = {};
    let prevEntry = null;

    for (const entry of schedule) {
      if (prevEntry !== null) {
        if (entry.start_time < prevEntry.end_time) {
          overlaps[prevEntry.id] = true;
          overlaps[entry.id] = true;
        }
      }
      prevEntry = entry;
    }

    return overlaps;
  }

  getScheduleErrors(schedule) {
    const errors = {msg: ''};

    schedule.forEach(
      entry =>
        errors[entry.id] = (timeStrToNum(entry.end_time) <= timeStrToNum(entry.start_time))
          ? 'Start time must be before end time.'
          : null,
    );

    return errors;
  }

  handleAddClick = () =>
    this.setState({adding: true, newTimeSlot: this.getNextTimeRange()})

  handleCancel = () =>
    this.setState({editing: false, schedule: this.props.schedule})

  handleCancelAdd = () => this.setState({newTimeSlot: null, adding: false});

  handleNewTimeSlotChange = (data) => this.setState({newTimeSlot: data});

  handleReschedule = () =>
    this.setState({editing: true})

  handleSave = () => {
    const sortedSchedule = sortBy(this.state.schedule, s => timeStrToNum(s.start_time));
    const overlaps = this.getOverlaps(sortedSchedule);

    if (isEmpty(overlaps)) {
      this.setState({
        editing: false,
        schedule: sortedSchedule,
        overlaps: {},
      });
      this.props.onReschedule(sortedSchedule);
    } else {
      this.setState({
        overlaps: overlaps,
      });
    }
  }

  handleSaveTimeSlot = () => {
    this.validateTime(
      this.props.onAddScheduleTimeSlot({...this.state.newTimeSlot, day: this.props.day}),
      this.setState({newTimeSlot: null, adding: false})
    )
  }

  handleScheduleTimeSlotChange = (data) => {
    const newSchedule = [...this.state.schedule];
    const idx = newSchedule.findIndex(sch => sch.id === data.id);

    if (idx >= 0) {
      newSchedule[idx] = data;
      this.setState({
        schedule: newSchedule,
      });
    }
  }

  handleToggleCollapse = () => this.setState({expanded: !this.state.expanded});

  render() {
    if (!this.state.expanded) return this.renderCollapsed();
    const errors = this.getScheduleErrors(this.state.schedule);

    return (
      <div className="schedule-view expanded card depth-3">
        <div className="header" onClick={this.handleToggleCollapse}>
          <h3>{this.props.day}</h3>
          <Icon title="Collapse" name="minus"/>
        </div>
        
        {this.state.schedule.map(entry => (
          <ScheduleEntryView key={entry.id}
                             profile={this.props.profile}
                             editing={this.state.editing}
                             deviceGroup={this.props.deviceGroup}
                             timeSlot={entry}
                             smartBoardEnabled={this.props.smartBoardEnabled}
                             error={errors[entry.id]}
                             overlaps={this.state.overlaps[entry.id]}
                             onContentFeedChange={this.props.onScheduleFeedChange}
                             onBringToFrontChange={this.props.onUpdateScheduleTimeSlot}
                             onTimeSlotChange={this.handleScheduleTimeSlotChange}
                             onDelete={this.props.onScheduleTimeSlotDelete}/>
        ))}
        {isEmpty(this.state.overlaps) ||
        <div className="label warning">Highlighted schedules are overlapping.</div>}
        {this.getActionBar()}
      </div>
    );
  }

  renderCollapsed() {
    return (
      <div className="schedule-view collapsed card depth-1">
        <div className="header" onClick={this.handleToggleCollapse}>
          <h3>Daily</h3>
          <Icon title="Expand" name="plus"/>
        </div>
      </div>
    );
  }
}
export default DailyScheduleView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DailyScheduleView/index.js